export const testimonials = [
  {
    name: "Maria Clara S.",
    city: "Fortaleza, CE",
    rating: 5,
    text: "Sanduíches deliciosos e sempre fresquinhos! Compro semanalmente para minha família e nunca me decepcionei. Recomendo demais!",
  },
  {
    name: "Joao Pedro M.",
    city: "Fortaleza, CE",
    rating: 5,
    text: "Contratamos a Big Mania para o coffee break da nossa empresa e foi um sucesso total. Organização impecável e comida maravilhosa.",
  },
  {
    name: "Ana Lucia R.",
    city: "Fortaleza, CE",
    rating: 5,
    text: "Sou revendedora dos produtos Big Mania há 3 anos. Qualidade consistente, entrega pontual e meus clientes adoram. Parceria de confiança!",
  },
  {
    name: "Carlos Eduardo B.",
    city: "Fortaleza, CE",
    rating: 4,
    text: "Excelente qualidade nos mini pastéis. Uso no meu mercadinho e são os mais vendidos. Preço justo e ótimo margem de lucro.",
  },
  {
    name: "Fernanda Lima",
    city: "Fortaleza, CE",
    rating: 5,
    text: "O sanduíche de peito de peru com mussarela é simplesmente divino! Sabor caseiro que lembra comida de verdade. Minha favorita!",
  },
  {
    name: "Ricardo Nogueira",
    city: "Fortaleza, CE",
    rating: 5,
    text: "Fornecemos Big Mania no refeitório da escola e as crianças adoram. Produtos nutritivos, bem apresentados e com preços competitivos.",
  },
];